// extracted by mini-css-extract-plugin
var _1 = "PageFromRailsStyles-module__page-from-rails___GFSOh";
var _2 = "PageFromRailsStyles-module__page-from-rails___GFSOh";
export { _1 as "page-from-rails", _2 as "pageFromRails" }
